import { AppDispatch, RootState } from "../../../redux/Store";
import { getIdentificationInfo } from "../../../redux/requests/IdentificationRequests";
import { identificationSlice } from "../../../redux/reducers/IdentificationSlice";
import { FC, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./Operator-request-status.css";

const IdentificationStatus: FC = () => {
  const dispatch = useDispatch<AppDispatch>();

  const { identification, isLoading, error } = useSelector(
    (state: RootState) => state.identification
  );

  const [passportNumber, setPassportNumber] = useState("");

  useEffect(() => {
    return () => {
      dispatch(identificationSlice.actions.identificationReset());
    };
  }, [dispatch]);

  const handleSearch = () => {
    const trimmedValue = passportNumber.trim();

    if (!trimmedValue) {
      dispatch(
        identificationSlice.actions.identificationFailed(
          "Введите серию и номер паспорта"
        )
      );
      return;
    }

    dispatch(getIdentificationInfo(trimmedValue));
  };

  return (
    <div>
      <div id="modal">
        <input
          type="text"
          placeholder="Введите серию и номер паспорта"
          value={passportNumber}
          onChange={(e) => setPassportNumber(e.target.value)}
        />

        <button onClick={handleSearch} disabled={isLoading}>
          {isLoading ? "Поиск..." : "Поиск"}
        </button>
      </div>

      <div id="search-box">
        {isLoading && <p>Загрузка...</p>}
        {error && <p>{error}</p>}

        {identification && (
          <div>
            <p>Паспорт: {identification.passportNumber}</p>
            <p>Телефон: {identification.phoneNumber}</p>
            <p>ИНН: {identification.tin}</p>
            <p>
              Фото паспорта: {identification.passportPhoto ? "Есть" : "Нет"}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default IdentificationStatus;